import * as voucherActionTypes from "../actions/types/voucherActionType";

const initialState = {
	loading: false,
	messages: [],
	voucher: {},
	error: null,
	reload: false
};

export default function voucherReducer(state = initialState, action) {
	let newState = {};
	switch (action.type) {
		// AddVoucher
		case voucherActionTypes.FETCH_ADDVOUCHER_REQUEST:
			newState = Object.assign({}, state, {
				error: null,
				loading: true,
				messages: [],
				reload: false
			});
			return newState;

		case voucherActionTypes.FETCH_ADDVOUCHER_SUCCESS:
			newState = Object.assign({}, state, {
				loading: false,
				wrongValidation: action.response && action.response.wrongValidation,
				messages:
					action.response && action.response.messages
						? action.response.messages
						: [],
				voucher:
					action.response && action.response.voucher ? action.response.voucher : {},
				reload:
					action.response.isSuccess &&
					(action.response.voucher.type == 0 ||
						(action.response.voucher.type != 0 &&
							action.response.voucher.token != null &&
							action.response.voucher.token != ""))
			});
			return newState;

		case voucherActionTypes.FETCH_ADDVOUCHER_FAILURE:
			newState = Object.assign({}, state, {
				error: action.error,
				loading: false,
				messages: [],
				voucher: {},
				reload: false
			});
			return newState;

		// RemoveVoucher
		case voucherActionTypes.FETCH_REMOVEVOUCHER_REQUEST:
			newState = Object.assign({}, state, {
				error: null,
				loading: true,
				messages: [],
				reload: false
			});
			return newState;

		case voucherActionTypes.FETCH_REMOVEVOUCHER_SUCCESS:
			newState = Object.assign({}, state, {
				loading: false,
				messages:
					action.response && action.response.messages
						? action.response.messages
						: [],
				voucher:
					action.response && action.response.voucher ? action.response.voucher : {},
				reload: action.response.isSuccess && action.response.voucher == null
			});
			return newState;

		case voucherActionTypes.FETCH_REMOVEVOUCHER_FAILURE:
			newState = Object.assign({}, state, {
				error: action.error,
				loading: false,
				messages: [],
				voucher: {},
				reload: false
			});
			return newState;
		case voucherActionTypes.VOUCHER_MIN_LENGTH_ERROR:
			newState = Object.assign({}, state, {
				messages: [{ key: 2, value: action.errorMessage }],
				voucher: Object.assign({}, state.voucher, {
					type: 0
				})
			});

			return newState;
		default:
			// ALWAYS have a default case in a reducer
			return state;
	}
}
